// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"dc0cdee7","188":"3cfa6a46","479":"c9accbe3","525":"44062532","568":"54d98c51","616":"de236cc4"}[chunkId] + ".css";
};